import {
    PostSubscriptionRequest, getSubscriptionRequest
} from "../repositories/subscription_repository";


export const SubscriptionService = () => {
    const createSubscription = async (subscriptionDetails, setSubscriptionList, setErrors) => {
        try {
            const response = await PostSubscriptionRequest(subscriptionDetails);
            if (response?.success) {
                setSubscriptionList((prevList) => [...prevList, response.data]);
                return true;
            } else {
                setErrors(response?.errors || {general : "Failed to create subscription."})
                return false;
            }
        } catch (error) {

            return false;
        };

    };

    const fetchSubscription = async (setSubscriptionList) => {
        try {
            const response = await getSubscriptionRequest();
            if (response?.success) {
                setSubscriptionList(response.data)
            }
        } catch (error) {
            console.error("Failed to fetch subscription data.")
        }
    }
    return {
        createSubscription,
        fetchSubscription,
    };
};